module.exports = __webpack_public_path__ + "img/auth.dde586ee.jpg";